import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";

import * as Yup from "yup";
import { useFormik } from "formik";

import { loginUser} from "../../slices/thunks";

import logoLight from "../../assets/images/vuelo/vueloBlanco1.png";
import { createSelector } from 'reselect';

const Login = (props: any) => {
    const dispatch: any = useDispatch();


    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading
        })
    );

    const {
        user, error, loading
    } = useSelector(loginpageData);


    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);

    const [loader, setLoader] = useState<boolean>(false);


    useEffect(() => {
        if (user && user) {
            const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.email;
            const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.confirm_password;
            setUserLogin({
                document: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);


    const validation: any = useFormik({
        enableReinitialize: true,

        initialValues: {
            document: userLogin.document || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            document: Yup.string().required("Por favor introduzca su número de identificación"),
            password: Yup.string().required("Por favor, introduzca su contraseña"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
        }
    });

    useEffect(() => {
        setLoader(loading)
    }, [dispatch, loading]);

    document.title = "Login | Vuelo";
    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logoLight} alt="" height="140" />
                                        </Link>
                                    </div>
                                    {/*<p className="mt-3 fs-15 fw-medium">Sistema de Facturación Electrónica</p>*/}
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">¡Bienvenido de nuevo!</h5>
                                            <p className="text-muted">Inicia sesión para acceder a tu sistema de facturación.</p>
                                        </div>
                                        {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="document" className="form-label">Número de
                                                        identifiación</Label>
                                                    <Input
                                                        name="document"
                                                        className="form-control"
                                                        placeholder="Ingrese usuario"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.document || ""}
                                                        invalid={
                                                            !!(validation.touched.document && validation.errors.document)
                                                        }
                                                    />
                                                    {validation.touched.document && validation.errors.document ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.document}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">¿Olvidaste tu contraseña?</Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Contraseña</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Recordar sesión</Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button color="success"
                                                            disabled={loader && true}
                                                            className="btn btn-success w-100" type="submit">
                                                        {loader &&
                                                            <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                                        Iniciar sesión
                                                    </Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                                {/*  <div className="mt-4 text-center">
                                    <p className="mb-0">¿No tienes una cuenta? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Regístrate aquí </Link> </p>
                                </div>*/}

                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);
